<template>
  <!-- <div class="preface">
    <img src="@/assets/pingxuan2022/pc/images/introduction.png" alt="">
  </div> -->
  <div class="preface">
    <div class="p-logo">
    </div>
    <div class="p-detail">
      <span class="pd-2">
        <div class="pd-2-desc">随着2024年的落幕，我们站在新旧交替的节点上，回望这一年科技领域的辉煌成就。在极果2024年终评选，我们从36个不同品类中，精选出了对用户体验带来真正“有效创新”的产品，它们是科技创新的尖峰，更是行业发展的风向标。</div>
        <div class="pd-2-desc">从十大创新奖到各类年度最佳产品，本次评选涵盖智能手机、平板、笔记本、可穿戴设备、家电、汽车、智驾系统、路由器、相机及教育硬件等众多领域，展现了科技的飞速发展与创新融合。这些奖项不仅彰显了技术的进步，更体现了创新精神对提升生活品质和工作效率的巨大推动作用，让科技真正有效改善我们都生活质量。</div>
      </span>
    </div>
    <div class="quotation"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created () { },
  methods: {},
  computed: {},
  mounted () { },
};
</script>

<style lang='scss' scoped>
// .preface {
//   width: 1000px;
//   height: 271px;
//   margin: 0 auto;
//   padding-bottom: 6px;

//   img{
//     width: 100%;
//   }
// }

.preface{
  font-family: "SimHei", "黑体", sans-serif;
  width: 1000px;
  padding: 0px 0 0px 0;
  border-radius: 8px;
  color: #FFF6D3;

  .p-logo{
    padding: 0 0 0 27px;
    .pl-1{
      display: inline-block;
      width: 15px;
      height: 6px;
      background: #FFDF00;
    }
    .pl-2{
      display: inline-block;
      width: 72px;
      height: 6px;
      background: #E22B41;
    }
  }
  .p-detail{
    text-align:justify;
    width: 943px;
    margin: 0 auto;
    padding-top: 0px;
    .pd-1{
      font-size: 28px;
      font-weight: bold;
      line-height: 35px;
    }
    .pd-2{
      font-size: 18px;
      line-height: 31px;
    }
  }
  .quotation{
    width: 37px;
    height: 31px;
    background: url("~@/assets/pingxuan2022/pc/images/quotation.png") no-repeat;
    background-size: 100%;
    margin: 11px 0 0 935px;
  }
}
.pd-2-desc{
  margin-top: 36px;
}
</style>
